'use strict';

function getSessionVariableKey(uuid, textKey) {
  return `mpp-edit-information-${uuid}-${textKey}`;
}

function removeFromStorage(uuid, textKey) {
  return typeof sessionStorage !== 'undefined' && sessionStorage !== null
    ? sessionStorage.removeItem(getSessionVariableKey(uuid, textKey))
    : undefined;
}

function getFromStorage(uuid, textKey) {
  return typeof sessionStorage !== 'undefined' && sessionStorage !== null
    ? sessionStorage.getItem(getSessionVariableKey(uuid, textKey))
    : undefined;
}

function setToStorage(uuid, textKey, value) {
  if (typeof sessionStorage !== 'undefined' && sessionStorage !== null) {
    return sessionStorage.setItem(getSessionVariableKey(uuid, textKey), value);
  }
  return null;
}

class EditInformation {
  constructor(el) {
    this.submitForm = this.submitForm.bind(this);
    this.el = el;
    this.rootUrl = '/merchant-page';
    this.csrf = $('meta[name=csrf-token]').attr('content');
    this.uuid = $('#hiddenUUID').attr('value');
    this.$el = $(this.el);
    this.$loading = this.$el.find('.icon-g-loader'); // aggregation of form elements

    this.$formElements = {
      name: this.$el.find('.name-correction-text'),
      category: this.$el.find('.category-correction-text'),
      address: this.$el.find('.address-correction-text'),
      phone: this.$el.find('.phone-correction-text'),
      website: this.$el.find('.website-correction-text'),
      additionalSuggestions: this.$el.find('.suggestions'),
      permanentlyClosed: this.$el.find('.closed-checkbox-input'),
      flagged: {
        name: this.$el.find('.name.section-container'),
        category: this.$el.find('.category.section-container'),
        address: this.$el.find('.address.section-container'),
        phone: this.$el.find('.phone.section-container'),
        website: this.$el.find('.website.section-container'),
      },
    };
    this.inputMaxLengths = {
      name: 50,
      category: 100,
      address: 100,
      phone: 16,
      website: 200,
      additionalSuggestions: 400,
    }; // aggregation of modal inputs

    this.$inputs = {
      checkboxes: this.$el.find('.checkbox'),
      editInfoButton: $('.claim-your-page .edit-info-link'),
      editSectionButtons: this.$el.find('.section-container'),
      formSubmitButton: this.$el.find('.submit-btn'),
      hintButtons: this.$el.find('.icon-question'),
      resetSectionButtons: this.$el.find('.reset'),
    };
    this.autofillUserInput();
    this.bindEventHandlers();
  }

  readInputValues() {
    let attribute;
    const elementValues = {};

    for (attribute in this.$formElements) {
      const element = this.$formElements[attribute];

      if (attribute !== 'flagged' && attribute !== 'permanentlyClosed') {
        elementValues[attribute] = element.val();

        if (
          !elementValues[attribute] ||
          elementValues[attribute].length > this.inputMaxLengths[attribute]
        ) {
          elementValues[attribute] = null;
        }
      }
    }

    elementValues[
      'permanentlyClosed'
    ] = this.$formElements.permanentlyClosed.prop('checked') ? 'CLOSED' : ''; // Empty input values are replaced with either 'None' or null depending on whether the section was flagged or not
    // 'None' represents flagged content, while null represents the absence of a submission value entirely

    for (attribute in elementValues) {
      const value = elementValues[attribute];

      if (value === '') {
        elementValues[attribute] = (this.$formElements.flagged[attribute] !=
        null
        ? this.$formElements.flagged[attribute].hasClass('editable')
        : undefined)
          ? 'None'
          : null;
      }
    }

    return elementValues;
  }

  autofillUserInput() {
    const corrections = JSON.parse(getFromStorage(this.uuid, 'corrections'));
    removeFromStorage(this.uuid, 'corrections');
    return (() => {
      const result = [];

      for (const attribute in corrections) {
        const value = corrections[attribute];

        if (attribute === 'permanentlyClosed') {
          if (value !== null) {
            result.push(
              this.$formElements[attribute] != null
                ? this.$formElements[attribute].prop('checked', true)
                : undefined
            );
          } else {
            result.push(undefined);
          }
        } else {
          if (value !== null && attribute !== 'additionalSuggestions') {
            this.$formElements.flagged[attribute].addClass('editable');
          }

          if (value !== 'None') {
            result.push(this.$formElements[attribute].val(value));
          } else {
            result.push(undefined);
          }
        }
      }

      return result;
    })();
  } // perform checkbox UI changes on click

  registerCheckboxes() {
    return this.$inputs['checkboxes'].click(event => {
      const $container = $(event.currentTarget).parents(
        '.closed-checkbox-container'
      );
      return $container.toggleClass('checked');
    });
  }

  registerEditSections() {
    return this.$inputs['editSectionButtons'].click(function() {
      const $section = $(this);

      if (!($section.hasClass('editable') || $section.hasClass('no-hover'))) {
        return $section.addClass('editable');
      }
      return null;
    });
  }

  registerResetButtons() {
    return this.$inputs['resetSectionButtons'].click(event => {
      const $section = $(event.currentTarget).parent();
      $section.removeClass('editable'); // This prevents the containing element from toggling .editable back on

      event.stopPropagation();
      return $section.find('input[type=text]').val('');
    });
  }

  lazyLoadImages() {
    return this.$el
      .find('.lazy-loaded-image')
      .each((position, imageElement) => {
        const $image = $(imageElement);
        return $image.attr('src', $image.attr('lazy-load-src'));
      });
  }

  bindEventHandlers() {
    this.$inputs['editInfoButton'].click(() => {
      MPP.Modal.open(this.el);
      return this.lazyLoadImages();
    }); // Register click and hover events for all modal buttons

    this.registerCheckboxes();
    this.registerEditSections();
    this.registerResetButtons();
    return this.$inputs['formSubmitButton'].click(() => this.submitForm());
  } // send user submitted corrections to UGC Hivemind.
  // Users are prompted to login if they aren't already,
  // or redirected back to the page on successful submission.

  submitForm() {
    const corrections = this.readInputValues();

    if (!(_.compact(_.values(corrections)).length > 0)) {
      return null;
    }

    const obj = {
      _csrf: this.csrf,
      uuid: this.uuid,
      corrections,
    };
    this.$inputs['formSubmitButton'].hide();
    this.$loading.show();
    $.ajax({
      url: `${this.rootUrl}/edit-information`,
      method: 'POST',
      data: JSON.stringify(obj),
      contentType: 'application/json',
      success: res => {
        this.$loading.hide();
        this.$inputs['formSubmitButton'].show();

        if (MPP.JsonResponseHandler.loginRequired(res)) {
          setToStorage(
            this.uuid,
            'corrections',
            JSON.stringify(obj.corrections)
          );
          GIG.Modal.close();
          MPP.JsonResponseHandler.openModalIframeLogin();
        }

        if (res.result !== 'ok') {
          return null;
        }

        this.$el.find('.thankyou-content').css('display', 'block');
        return this.$el.find('.edit-content').css('display', 'none');
      },

      error() {
        //we timed out
        this.$loading.hide();
        return this.$inputs['formSubmitButton'].show();
      },
    });
    return true;
  }
}

$(() => new EditInformation('#edit-information-modal'));
